module.exports = __webpack_public_path__ + "static/cta-growth-cb6cedf8b90dfe2534f0e9d6da8f66ea.png";